import {
  UPDATE_CAMPAIGNS,
  UPDATE_CAMPAIGN_SELECT,
  UPDATE_CAMPAIGN_SELECT_DEFAULT,
  UPDATE_CLIENTS_BY_PARTNER,
  UPDATE_CLIENTS_CAMPAIGN_BY_ID,
  UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN,
  UPDATE_CLIENTS_ASSOCIATED_EDIT_CAMPAIGN,
  SET_CAMPAIGN_PROPERTY,
  UPDATE_CAMPAIGN_FRONT_DETAIL,
  UPDATE_CAMPAIGN_CLONE_DATA,
  COPY_CAMPAIGN_SELECTED_DATA,
  UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED,
  CAMPAIGN_FRONT_DETAIL_RESET,
  UPDATE_SECTION_ODATA,
  RESET_SECTION_ODATA,
  UPDATE_CAR_FEATURES,
  RESET_EDIT_CAMPAIGN_FIELDS_CHANGED,
  UPDATE_MULTIPLE_CAMPAIGNS_EDIT,
  UPDATE_MASTER_DATA_CAMPAIGN,
  UPDATE_STOCK_RESERVED,
  UPDATE_ODATA_BY_DRAG_AND_DROP,
  SET_CAMPAIGNS_USE_TO_SORT,
  SET_CAMPAIGN
} from 'store/actions/campaign';
import { setValueObjectByField, sortArrayByAttr, moveArrayItemToNewIndex } from 'helpers/object';
import { number, currency } from 'helpers/number';
import { dateToString } from 'helpers/date';
import { i18n } from '@/setup/i18n';

export default {
  [SET_CAMPAIGN_PROPERTY]: (state, { field, value, tabName }) => {
    if (state.editCampaignFieldsChanged[tabName]) {
      state.editCampaignFieldsChanged[tabName][field.substr(field.indexOf('.') + 1)] = value;
    } else {
      state.editCampaignFieldsChanged[tabName] = {};
      state.editCampaignFieldsChanged[tabName][field.substr(field.indexOf('.') + 1)] = value;
    }

    const objFromState = { ...state[field.substr(0, field.indexOf('.'))] };
    setValueObjectByField(objFromState, field.substr(field.indexOf('.') + 1), value);
    state[field.substr(0, field.indexOf('.'))] = {
      ...objFromState
    };
  },
  [SET_CAMPAIGN]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UPDATE_CAMPAIGNS]: (state, campaigns) => {
    state.campaigns = campaigns.map(item => {
      const objFormat = item;
      objFormat.toDate = dateToString(item.toDate);
      objFormat.toDateInvisibility = dateToString(item.toDateInvisibility);
      objFormat.timeStamp = dateToString(item.timeStamp);
      objFormat.email = item.value.email;
      objFormat.urlPhoto = item.value.urlPhoto[0];
      objFormat.monthFee = item.value.monthFee;
      objFormat.vehicle = item.value.vehicle;
      objFormat.accessories = item.value.accessories;
      objFormat.termInMonths = item.value.termInMonths;
      objFormat.yearKms = item.value.yearKms;
      objFormat.downPayment = item.value.downPayment;
      objFormat.make = item.value.make;
      objFormat.model = item.value.model;
      objFormat.version = item.value.version;
      objFormat.logoFrontLeft = item.value.logoFrontLeft;
      objFormat.vehicleType = item.value.vehicleType;
      objFormat.currentKilometers = item.value.currentKilometers;
      objFormat.registrationYear = item.value.registrationYear;
      objFormat.contractVersion = item.contractValue.version;
      objFormat.stockAvailable = item.stock ? item.stock.available : 0;
      objFormat.car = item.car;
      return objFormat;
    });
  },

  [UPDATE_CAMPAIGN_SELECT]: (state, data) => {
    state.select = data;
    if (data.contractValue && data.contractValue.tableServices) {
      const tableServices = sortArrayByAttr(data.contractValue.tableServices, 'lbl');
      state.select.contractValue.tableServices = tableServices;
    }
  },

  [UPDATE_CAMPAIGN_SELECT_DEFAULT]: (state, data) => {
    state.selectDefault = data;
  },

  // eslint-disable-next-line complexity
  [UPDATE_CAMPAIGN_FRONT_DETAIL]: (state, campaign) => {
    const {
      serviceList,
      campaignDetail,
      car,
      insuranceTypes,
      nonEditableFields,
      urlDigitalContract,
      campaignType,
      contractMaxAge,
      contractMinAge,
      minYearDriverLicense
    } = campaign;
    // Created offer detail object
    const {
      make,
      model,
      version,
      rangeKms,
      legalText,
      taxType,
      urlPhoto,
      monthFee,
      monthFeeWithoutTaxes,
      insuranceMonthFee,
      totalAmountToBePaid,
      vehicleType,
      doors,
      accessories,
      settings,
      termInMonths,
      yearKms,
      downPayment,
      warrantyFee,
      warrantyFeeDescription,
      stock,
      stockAlert,
      campaignFactory
    } = campaignDetail;
    const hasTotalAmount = insuranceMonthFee && totalAmountToBePaid;
    const bulletPoints = car.bulletPoints || [];
    let extraInformation = '';
    bulletPoints.forEach((element, index) => {
      if (index === 0) extraInformation = '<ul>';
      extraInformation += `<li>${element}</li>`;
      if (bulletPoints.length - 1 === index) extraInformation += '</ul>';
    });
    state.campaignDetail = {
      title: `${make} ${model}`,
      subTitle: version,
      badgeCampaignType: car && car.vehicleStatus ? car.vehicleStatus : null,
      badgeColor: car && car.colorName ? `${i18n.t('ui.label.color')} ${car.colorName}` : null,
      badgeRangeKms: rangeKms,
      badgeCampaignFactory: campaignFactory,
      legal: legalText,
      taxType,
      photos: urlPhoto,
      value: hasTotalAmount ? `${currency(totalAmountToBePaid)}/mes` : `${currency(monthFee)}/mes`,
      monthFeeWithoutTaxes: `${currency(monthFeeWithoutTaxes)}/mes`,
      rentingFee: hasTotalAmount ? `${currency(monthFee)}/mes` : '',
      insuranceFee: hasTotalAmount ? `${currency(insuranceMonthFee)}/mes` : '',
      insuranceTypes,
      stock,
      stockAlert,
      properties: [
        {
          name: i18n.t('ui.label.type'),
          description: `${vehicleType} ${doors} puertas.`
        },
        {
          name: i18n.t('ui.label.optionIncluded'),
          description: accessories
        },
        {
          name: i18n.t('ui.label.servicesIncluded'),
          description: serviceList
        },
        {
          name: i18n.t('ui.label.settingsIncluded'),
          description: settings
        }
      ],
      features: [
        {
          title: i18n.t('ui.label.limit'),
          value: `${termInMonths} meses`,
          icon: 'clock-o'
        },
        {
          title: i18n.t('ui.label.yearKmsUnit'),
          value: number(yearKms),
          icon: 'tachometer'
        }
      ],
      extraInformation,
      nonEditableFields,
      urlDigitalContract,
      vehiculoRtsV2: car.vehiculoRtsV2 || '',
      contractMaxAge,
      contractMinAge,
      minYearDriverLicense
    };

    if (warrantyFeeDescription) {
      state.campaignDetail.properties.push({
        name: i18n.t('ui.label.warrantyFeeDescription'),
        description: warrantyFeeDescription
      });
    }

    if (downPayment != null) {
      state.campaignDetail.features.push({
        title: i18n.t('ui.label.initialContribution'),
        value: currency(downPayment),
        icon: 'ald-ico-euro'
      });
    }

    if (warrantyFee != null) {
      state.campaignDetail.features.push({
        title: i18n.t('ui.label.warrantyFeeDescriptionTitle'),
        value: currency(warrantyFee),
        icon: 'coins'
      });
    }

    state.campaignType = campaignType;
    state.stock = stock;
  },
  [UPDATE_CAMPAIGN_CLONE_DATA]: (state, data) => {
    state.campaignCloneData = data;
  },

  [UPDATE_CLIENTS_CAMPAIGN_BY_ID]: (state, data) => {
    if (data.ruta) {
      const clientsCampaignsNewRequiered = Object.assign([], data.clients);
      clientsCampaignsNewRequiered.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.label = item.nameCustomer;
        // eslint-disable-next-line no-param-reassign
        item.value = item.id;
      });
      state.clientsCampaigns = clientsCampaignsNewRequiered;
    } else {
      const clientsCampaignsProcessed = Object.assign([], state.clientsCampaigns);
      data.clients.forEach(item => {
        Object.values(clientsCampaignsProcessed).forEach(client => {
          if (client.idCustomer === item.idCustomer) {
            // eslint-disable-next-line no-param-reassign
            client.selected = true;
          }
        });
      });
      state.clientsCampaigns = clientsCampaignsProcessed;
    }
  },

  [UPDATE_CLIENTS_BY_PARTNER]: (state, data) => {
    /* eslint-disable no-param-reassign */
    const clientsCampaignsProcessed = Object.assign([], data);
    clientsCampaignsProcessed.forEach(item => {
      item.selected = false;
      item.visible = true;
    });
    state.clientsCampaigns = clientsCampaignsProcessed;
  },

  [UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN]: (state, data) => {
    const objEditDataCampaign = { ...state.editDataCampaign };
    objEditDataCampaign.customers.selectedDefault = data;
    state.editDataCampaign = { ...objEditDataCampaign };
  },

  [UPDATE_CLIENTS_ASSOCIATED_EDIT_CAMPAIGN]: (state, data) => {
    const objEditDataCampaign = { ...state.editDataCampaign };
    objEditDataCampaign.customers.associated = data;
    state.editDataCampaign = { ...objEditDataCampaign };
  },

  [COPY_CAMPAIGN_SELECTED_DATA]: state => {
    state.newCampaign = { ...state.select };
    state.newCampaign.campaignName = '';
    state.newCampaign.clients = state.campaignCloneData.clients;
    state.newCampaign.car = {
      multimediaFunctionality: '',
      specialFeatures: '',
      ...state.select.car
    };
  },

  [UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED]: (state, value) => {
    state.newCampaign.clients = value;
  },

  [CAMPAIGN_FRONT_DETAIL_RESET]: state => {
    state.campaignDetail = null;
  },

  [UPDATE_SECTION_ODATA]: (state, data) => {
    state.odataItems = data;
  },

  [RESET_SECTION_ODATA]: state => {
    state.odataItems = null;
  },

  [UPDATE_CAR_FEATURES]: (state, data) => {
    state.carFeatures = data;
  },

  [RESET_EDIT_CAMPAIGN_FIELDS_CHANGED]: state => {
    state.editCampaignFieldsChanged = {};
  },
  [UPDATE_MULTIPLE_CAMPAIGNS_EDIT]: (state, data) => {
    state.multipleCampaignsEdit = data;
  },
  [UPDATE_MASTER_DATA_CAMPAIGN]: (state, data) => {
    state.masterDataCampaign = data;
  },
  [UPDATE_STOCK_RESERVED]: (state, updatedStock) => {
    state.select.stock.reserved = updatedStock;
  },

  [SET_CAMPAIGNS_USE_TO_SORT]: (state, data) => {
    state.useToSort = data;
  },

  [UPDATE_ODATA_BY_DRAG_AND_DROP]: (state, { newIndex, oldIndex, maxTopCampaigns }) => {
    state.sortedCampaigns = [];
    const sortedArr = moveArrayItemToNewIndex(state.useToSort, oldIndex, newIndex);
    sortedArr.forEach((item, index) => {
      if (index > maxTopCampaigns) return;
      state.sortedCampaigns.push({ campaignId: item.id, order: index });
      state.hasMoveCampaign = true;
    });
  }
};
